module.exports = __webpack_public_path__ + "img/AddPosHelp4.df73e778.png";